function ClickDelay() {
  $('[data-click-delay]').on('click', function (e) {
    const $elem = $(e.currentTarget);

    $elem.prop('disabled', true);
    setTimeout(function () {
      $elem.prop('disabled', false);
    }, 500);

    // Se for um botão de submit, eu tenho que dar submit
    // logo apos porque quando eu desabilito o botão ele para
    // o evento de submit natural do botão
    if ($elem.is(':submit') && $elem.prop('form')) {
      $(e.currentTarget.form).trigger('submit');
    }
  });
}

exports.init = ClickDelay;
